import React, { useState, useEffect, Fragment } from "react";
import { Button, Form, Row, Col } from "react-bootstrap";
import SVG from "react-inlinesvg";
import Scrollbars from "react-custom-scrollbars";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
// import PropTypes from "prop-types";
// import { connect } from "react-redux";
import { useFormik } from "formik";
import * as yup from "yup";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import {
  add_category_admin_menu_setup,
  edit_category_admin_menu_setup,
} from "../../../../../store/actions/SuperAdminActions/adminCreateCatalogue";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
//import Media from "react-media";

import { NewInputText } from "../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
//import { SliderReusableComponent } from "../../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
//import { BackLogoIconButton } from "../../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import {
  ReusableOnboardingButton,
  ReusableOnboardingLink,
} from "../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { TopTextReusableComponent } from "../../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import { AmealioLoader } from "../../../../Loader/AmealioLoader";
import { AddButtonIconComponent } from "../../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
//import { MobileTopHeader } from "../../../../reusableComponents/sliderReusableComponent/MobileTopHeader";
import { ToggleButtonWithYesNo } from "../../../../vendorOnboradingComponents/allScreens/NewSubscriptionScreen/AllButton/ToggleButtonReuse";
import TaxesSurCharges, {
  AddSurchargesModel,
} from "../../../../vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/MenuSetup/TaxesSurCharges";

import { Paper, IconButton } from "@material-ui/core";
import InputBase from "@material-ui/core/InputBase";
import KeyboardVoiceIcon from "@material-ui/icons/KeyboardVoice";

const SuperAdminAddCategory = (props) => {
  let history = useHistory();
  const { transcript } = useSpeechRecognition();

  const [showAddedTaxes, setShowAddedTaxes] = useState(true);
  //const [file, setFile] = useState(null);
  const [WithTaxes, setWithTaxes] = useState(true);
  const [active, setActive] = useState("PERCENTAGE");
  const [step, setStep] = useState(1);
  const [errors, setErrors] = useState({});
  const [keywords, setKeywords] = useState([]);
  const [keywordsText, setKeywordsText] = useState("");
  const [utterancesVoice, setUtterancesVoice] = useState([]);
  const [utterancesVoiceText, setUtterancesVoiceText] = useState("");
  // const uploadImage = (e) => {
  //   setFile(URL.createObjectURL(e.target.files[0]));
  // };
  const handleWithTaxes = () => {
    setWithTaxes(!WithTaxes);
  };

  const handleNextStep = (e) => {
    setStep(e);
  };

  /*******************************
   * Add Utterances Voice Action
   ******************************/
  const handleKeyUttrences = (event) => {
    if (event.key === "Enter") {
      let utterancesVoiceTextVr = utterancesVoiceText;
      let utterancesVoiceArr = utterancesVoice;
      if (utterancesVoiceTextVr === "") {
        errors.utterancesVoiceTextVr = "Utterances voice is Required";
        setErrors({
          errors: errors,
        });
      } else if (
        utterancesVoiceArr.some((diner) => diner === utterancesVoiceTextVr)
      ) {
        alert("Utterances voice already exits");
      } else {
        utterancesVoiceArr.push(utterancesVoiceTextVr);
        setUtterancesVoice(utterancesVoiceArr);
        formik.setFieldValue("utterancesVoice", utterancesVoiceArr);
        setUtterancesVoiceText("");
      }
    }
  };

  const addUtterancesVoiceAction = (e) => {
    e.preventDefault();
    let utterancesVoiceTextVr = utterancesVoiceText;
    let utterancesVoiceArr = utterancesVoice;
    if (utterancesVoiceTextVr === "") {
      errors.utterancesVoiceTextVr = "Utterances voice is Required";
      setErrors({
        errors: errors,
      });
    } else if (
      utterancesVoiceArr.some((diner) => diner === utterancesVoiceTextVr)
    ) {
      alert("Utterances voice already exits");
    } else {
      utterancesVoiceArr.push(utterancesVoiceTextVr);
      setUtterancesVoice(utterancesVoiceArr);
      formik.setFieldValue("utterancesVoice", utterancesVoiceArr);
      setUtterancesVoiceText("");
    }
  };

  const addUtterancesVoiceActionMic = (valueText) => {
    //e.preventDefault();
    let utterancesVoiceTextVr = valueText;
    let utterancesVoiceArr = utterancesVoice;
    if (utterancesVoiceTextVr === "") {
      errors.utterancesVoiceTextVr = "Uterances voice is Required";
      setErrors({
        errors: errors,
      });
    } else if (
      utterancesVoiceArr.some((diner) => diner === utterancesVoiceTextVr)
    ) {
      alert("Utterances voice already exits");
    } else {
      utterancesVoiceArr.push(utterancesVoiceTextVr);
      setUtterancesVoice(utterancesVoiceArr);
      formik.setFieldValue("utterancesVoice", utterancesVoiceArr);
      setUtterancesVoiceText("");
    }
  };

  /*************************************
   * @DESC Utterances Voice Change Handlers
   ************************************/
  const onUtterancesVoiceChangeHandler = (e) => {
    setUtterancesVoiceText(e.target.value);
  };
  /*************************************
   * @DESC Remove utterancesVoice Change Handlers
   ************************************/
  const removeUtterancesVoiceAction = (indexId) => (e) => {
    var data = [...utterancesVoice];
    data.splice(indexId, 1);
    setUtterancesVoice(data);
    formik.setFieldValue("utterancesVoice", data);
  };

  /*******************************
   * Add Keywords Action
   ******************************/
  const addKeywordsAction = (e) => {
    e.preventDefault();
    let keywordsTextVr = keywordsText;
    let keywordsArr = keywords;
    if (keywordsTextVr === "") {
      errors.keywordsTextVr = "Keywords is Required";
      setErrors({
        errors: errors,
      });
    } else if (keywordsArr.some((diner) => diner === keywordsTextVr)) {
      alert("Keywords Already Exits");
    } else {
      keywordsArr.push(keywordsTextVr);
      setKeywords(keywordsArr);
      formik.setFieldValue("keywords", keywordsArr);
      setKeywordsText("");
    }
  };

  // const addKeywordsActionMic = (valueText) => {
  //   //e.preventDefault();
  //   let keywordsTextVr = valueText;
  //   let keywordsArr = keywords;
  //   if (keywordsTextVr === "") {
  //     errors.keywordsTextVr = "Keywords is Required";
  //     setErrors({
  //       errors: errors,
  //     });
  //   } else if (keywordsArr.some((diner) => diner === keywordsTextVr)) {
  //     alert("Keywords Already Exits");
  //   } else {
  //     keywordsArr.push(keywordsTextVr);
  //     setKeywords(keywordsArr);
  //     setKeywordsText("");
  //   }
  // };

  /*************************************
   * @DESC Keywords Change Handlers
   ************************************/
  const onKeywordsChangeHandler = (e) => {
    setKeywordsText(e.target.value);
  };
  /*************************************
   * @DESC Remove Keywords Change Handlers
   ************************************/
  const removeKeywordsAction = (indexId) => (e) => {
    var data = [...keywords];
    data.splice(indexId, 1);
    setKeywords(data);
    formik.setFieldValue("keywords", data);
  };

  const [categoryClassification, setClassification] = useState(
    props?.categoryClassification
  );

  const productClassification = [
    { id: 1, name: "Food & Beverage" },
    { id: 2, name: "F&B Packed Items" },
  ];

  const [count, setCount] = useState(1);

  const onClickNext = (e) => {
    e.preventDefault();
    setCount(count + 1);
    formik.handleSubmit();
  };

  const Capitalize = (str, name) => {
    return formik.setFieldValue(
      name,
      str.charAt(0).toUpperCase() + str.slice(1)
    );
  };

  const titleCase = (str, name) => {
    str = str.toLowerCase().split(" ");
    for (var i = 0; i < str.length; i++) {
      str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
    }
    return formik.setFieldValue(name, str.join(" "));
  };

  useEffect(() => {
    if (formik.errors && formik.errors.name) {
      let catNameElement = document.getElementById("name");
      catNameElement.focus();
    } else if (formik.errors && formik.errors.category_classification) {
      let categoryClassficationElement = document.getElementById(
        "category_classification"
      );
      categoryClassficationElement.focus();
    } else if (formik.errors && formik.errors.product_classification) {
      let productClassficationElement = document.getElementById(
        "product_classification"
      );
      productClassficationElement.focus();
    }
  }, [count]);

  const formik = useFormik({
    initialValues: {
      name: "",
      description: "",
      category_classification: "",
      product_classification: "Food & Beverage",
      charges: [],
      is_global: props.type === "chain" ? false : true,
      is_chain_catalogue: props.type === "chain" ? true : false,
      keywords: [],
      utterancesVoice: [],
    },
    validationSchema: yup.object({
      name: yup
        .string()
        .max(128, "Must be 128 characters or less")
        .required("Category name is required"),
      category_classification: yup
        .string()
        .required("Please select category classification"),
      product_classification: yup
        .string()
        .required("Please select product classification"),
    }),
    onSubmit: (values) => {
      formik.setFieldValue("keywords", keywords);
      formik.setFieldValue("utterancesVoice", utterancesVoice);
      // handleNextStep(2);
      let formData = {};
      formData = { ...values };
      const token = props.auth.user.accessToken;
      if (
        props &&
        props.activeCategoryData &&
        props.activeCategoryData._id &&
        props.activeCategoryData._id.length > 2
      ) {
        let msg = "Category edited Successfully";
        props.edit_category_admin_menu_setup(
          props.activeCategoryData._id,
          formData,
          token,
          onSuccess,
          msg
        );
      } else {
        props.add_category_admin_menu_setup(formData, token, onSuccess);
      }
    },
  });

  const onSuccess = () => {
    if (props.type === "chain") {
      history.push("/superadmin-chain-items-management/category");
    } else {
      history.push("/superadmin-global-items-management/category");
    }
  };

  const formikStepTwo = useFormik({
    initialValues: {
      test: "",
    },
    //validate,
    onSubmit: (values) => {
      let formData = {};
      formData = { ...formik.values };

      if (WithTaxes) {
        formData.price_include_tax = true;
        //formData.cross_selling = {};
        formData.charges = taxValues;
      } else {
        formData.price_include_tax = false;
        //formData.cross_selling = {};
        formData.charges = taxValues;
      }
      const token = props.auth.user.accessToken;
      if (
        props &&
        props.activeCategoryData &&
        props.activeCategoryData._id &&
        props.activeCategoryData._id.length > 2
      ) {
        let msg = "Category edited Successfully";
        props.edit_category_admin_menu_setup(
          props.activeCategoryData._id,
          formData,
          token,
          onSuccess,
          msg
        );
      } else {
        props.add_category_admin_menu_setup(formData, token, onSuccess);
      }
    },

    // handleNextStep(2);
  });
  const [addsurcharges, setAddSurcharges] = React.useState(false);
  const openAddSurcharges = () => {
    setAddSurcharges(true);
  };
  const closeAddSurcharges = () => {
    setAddSurcharges(false);
  };
  const onClickSave = () => {
    formikStepTwo.handleSubmit();
  };

  const [addNewTaxes, setAddNewTaxes] = useState([]);

  const [taxCode, setTaxCode] = useState([]);
  const [taxValues, setTaxValues] = useState([]);
  const [showSkipTheLine, setSHowSkipLine] = useState(false);
  const [showTakeAway, setShowTakeAway] = useState(true);
  const [showCurbSide, setShowCurbSide] = useState(false);
  const [showDineIn, setShowDineIn] = useState(false);

  const onChangeValue = (e, name, id) => {
    let existingData = [];

    for (let i = 0; i < taxValues.length; i++) {
      if (id === taxValues[i]._id) {
        let data = JSON.parse(JSON.stringify(taxValues[i]));
        data[name] = e;
        existingData.push(data);
      } else {
        existingData.push(taxValues[i]);
      }
    }
    setTaxValues(existingData);
  };

  const onClickSaveModalData = (data) => {
    const existingTaxes = [];
    for (let i = 0; i < addNewTaxes.length; i++) {
      if (data.id === addNewTaxes[i].id) {
        setTaxValues([...taxValues, data]);
      } else {
        existingTaxes.push(addNewTaxes[i]);
      }
    }
    setAddNewTaxes(existingTaxes);
  };

  useEffect(() => {
    if (
      props &&
      props.activeCategoryData &&
      props.activeCategoryData._id &&
      props.activeCategoryData._id.length > 2
    ) {
      let data = props.activeCategoryData;
      formik.setFieldValue("name", data.name);

      if (data.keywords) {
        setKeywords(data.keywords);
      }

      if (data.utterancesVoice) {
        setUtterancesVoice(data.utterancesVoice);
      }

      formik.setFieldValue("description", data.description);
      formik.setFieldValue(
        "category_classification",
        data.category_classification
      );
      formik.setFieldValue(
        "product_classification",
        data.product_classification
      );
      if (data.charges.length >= 1) {
        setWithTaxes(false);
      }
    }
  }, []);

  useEffect(() => {
    // if (props && props.subscriptionData && props.subscriptionData.tax_values) {
    //   setTaxValues(props.subscriptionData.tax_values);
    // }

    // if (props && props.subscriptionData && props.subscriptionData.tax_code) {
    //   setTaxCode(props.subscriptionData.tax_code);
    // }

    if (
      props &&
      props.activeCategoryData &&
      props.activeCategoryData._id &&
      props.activeCategoryData._id.length > 2 &&
      props &&
      props.subscriptionData &&
      props.subscriptionData.tax_values
    ) {
      //let

      let taxNames = {};
      let taxData = [];

      for (let i = 0; i < props.subscriptionData.tax_values.length; i++) {
        taxNames[i] = props.subscriptionData.tax_values[i].tax_name;
      }

      for (let i = 0; i < props.activeCategoryData.charges.length; i++) {
        if (props.activeCategoryData.charges[i].id in taxNames) {
          let existingD = JSON.parse(
            JSON.stringify(props.activeCategoryData.charges[i])
          );
          existingD.tax_name = taxNames[props.activeCategoryData.charges[i].id];
          taxData.push(existingD);
        } else {
          taxData.push(props.activeCategoryData.charges[i]);
        }
      }
      setTaxValues(taxData);

      let id = [];
      let newTaxes = [];

      for (let i = 0; i < taxData.length; i++) {
        id.push(taxData[i].id);
      }
      for (let j = 0; j < props.subscriptionData.tax_code.length; j++) {
        if (!id.includes(props.subscriptionData.tax_code[j].id)) {
          let prepData = {
            id: props.subscriptionData.tax_code[j].id,
            tax_name: props.subscriptionData.tax_code[j].description,
            tax_value: "PERCENTAGE",
            take_away: 0,
            curb_side: 0,
            dine_in_order: 0,
            catering_banquet: 0,
            home_delivery: 0,
            skip_line: 0,
          };
          newTaxes.push(prepData);
        }
      }
      setAddNewTaxes(newTaxes);
    } else if (
      props &&
      props.subscriptionData &&
      props.subscriptionData.tax_values
    ) {
      let id = [];
      let newTaxes = [];

      for (let i = 0; i < props.subscriptionData.tax_values.length; i++) {
        id.push(props.subscriptionData.tax_values[i].id);
      }

      for (let j = 0; j < props.subscriptionData.tax_code.length; j++) {
        if (!id.includes(props.subscriptionData.tax_code[j].id)) {
          let prepData = {
            id: props.subscriptionData.tax_code[j].id,
            tax_name: props.subscriptionData.tax_code[j].description,
            tax_value: "PERCENTAGE",
            take_away: 0,
            curb_side: 0,
            dine_in_order: 0,
            catering_banquet: 0,
            home_delivery: 0,
            skip_line: 0,
          };
          newTaxes.push(prepData);
        }

        setTaxValues(
          props && props.subscriptionData && props.subscriptionData.tax_values
        );
        setAddNewTaxes(newTaxes);
      }
    }
  }, [props.subscriptionData, props.activeCategoryData]);

  useEffect(() => {
    if (props.servicesEnabled && props.servicesEnabled.take_away.value) {
      setShowTakeAway(true);
    }

    if (props.checkSkipLine && props.checkSkipLine.fast_food_dining) {
      setSHowSkipLine(true);
    }

    if (props.servicesEnabled && props.servicesEnabled.cubside_delivery.value) {
      setShowCurbSide(true);
    }

    if (props.servicesEnabled && props.servicesEnabled.dine_in_order.value) {
      setShowDineIn(true);
    }
  }, [props.servicesEnabled, props.checkSkipLine]);

  useEffect(() => {
    if (transcript) {
      addUtterancesVoiceActionMic(transcript);
    }
  }, [transcript]);

  return (
    <>
      {props.auth.loader ? (
        <AmealioLoader />
      ) : (
        <React.Fragment>
          <div className="container-fluid">
            <div className="row">
              <div
                id="onboarding-scrollbar"
                className={`mobile-pb-70 p-lg-0 col-12 col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-6  new-subscription-onboarding-component `}
              >
                <div>
                  <div className="mb-4">
                    <TopTextReusableComponent
                      headingText={
                        props &&
                        props.activeCategoryData &&
                        props.activeCategoryData._id &&
                        props.activeCategoryData._id.length > 2
                          ? "Edit Global Category"
                          : "Add New Global Category"
                      }
                      headingParagraph="Manage your food items"
                    />
                  </div>
                  <Form>
                    {step === 1 && (
                      <React.Fragment>
                        <div className="nav-scroller mb-4">
                          <ul
                            className="enStepNav nav list-unstyled d-flex justify-content-between"
                            style={{ width: 300 }}
                          >
                            <li className="doing">
                              <div className="stepNumber">01</div>
                              <div className="text">Define Category</div>
                            </li>
                            {/* <li className="todo">
                              <div className="stepNumber">02</div>
                              <div className="text">Taxes & Other Details</div>
                            </li> */}
                          </ul>
                        </div>
                        <Form.Label className="f14-500 mb-3">
                          Add Menu Category
                        </Form.Label>
                        <Row>
                          <Col md={8}>
                            <NewInputText
                              controlClass={"name"}
                              labelText="Category Name"
                              extraClass={`mb-1 w-100 ${
                                formik.errors.name && formik.touched.name
                                  ? "enError"
                                  : ""
                              }`}
                              name="name"
                              //onChange={formik.handleChange}
                              onChange={(e) =>
                                titleCase(e.target.value, "name")
                              }
                              value={formik.values.name}
                              onFocusOut={formik.handleBlur}
                            />
                            {formik.errors.name && formik.touched.name ? (
                              <div className="pho_14_regular text-danger">
                                {formik.errors.name}
                              </div>
                            ) : null}
                          </Col>
                          <div className="mt-3 pl-3 col-sx-6 col-md-8">
                            <div className=" onboarding-restaurant-details-margin">
                              <div className="row align-items-center">
                                <div className="col-12">
                                  <Paper
                                    component="form"
                                    className="enSearch2 d-flex"
                                  >
                                    <InputBase
                                      placeholder="Utterances for Voice"
                                      inputProps={{
                                        "aria-label": "Add Utterances",
                                      }}
                                      name="utterancesVoiceText"
                                      onChange={onUtterancesVoiceChangeHandler}
                                      value={utterancesVoiceText}
                                      onKeyPress={(e) => {
                                        if (e.which == 13) {
                                          e.preventDefault();
                                        }
                                      }}
                                      onKeyDown={handleKeyUttrences}
                                      className="w-100 px-3"
                                    />
                                    <IconButton
                                      type="button"
                                      aria-label="Add Utterances"
                                      onClick={SpeechRecognition.startListening}
                                    >
                                      <KeyboardVoiceIcon />
                                    </IconButton>
                                  </Paper>
                                  {/* <NewInputText
                        extraClass="mb-1"
                        name="utterancesVoiceText"
                        onChange={onUtterancesVoiceChangeHandler}
                        value={utterancesVoiceText}
                        labelText="Utterances for Voice"
                        inputType="text"
                        onKeyPress={(e) => {
                          if (e.which == 13) {
                            e.preventDefault();
                          }
                        }}
                        onKeyDown={handleKeyUttrences}
                      /> */}
                                  <div className="MuiFormHelperText-root MuiFormHelperText-root Mui-error ">
                                    {errors.utterancesVoiceText !== ""
                                      ? errors.utterancesVoiceText
                                      : "Please add different utterances of the Menu Item"}
                                  </div>
                                  <div className="opacity5 f10-400">
                                    Please add different utterances of the Menu
                                    Item
                                    {/* <p>
                                  {transcript
                                    ? transcript
                                    : "Start listening for transcript"}
                                </p> */}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <Col md={4} xs={4} className="mt-3">
                            {/* <Button
                  variant="secondary"
                  onClick={SpeechRecognition.startListening}
                >                  
                </Button> */}
                            <div
                              className="f10-400 mt-2"
                              style={{ color: "#2096F3" }}
                            >
                              <AddButtonIconComponent
                                buttonText="Add Utterances"
                                onClick={addUtterancesVoiceAction}
                                fontIcon="fa fa-plus"
                                colorCss="blue"
                              />
                            </div>
                          </Col>
                          {utterancesVoice && utterancesVoice.length > 0 ? (
                            <Col md={12} className="mt-3">
                              <div className="col-12 p-0 onboarding-restaurant-details-margin">
                                <div className="row enChipBox border-0">
                                  {/* <Scrollbars
                                  style={{ width: "100%", height: 135 }}
                                > */}
                                  {utterancesVoice &&
                                    utterancesVoice.map((data, index) => {
                                      return (
                                        <div className="mb-3 mr-3" key={index}>
                                          <div className="keywords_button">
                                            <p>{data}</p>
                                            <span
                                              className="ml-2"
                                              onClick={removeUtterancesVoiceAction(
                                                index
                                              )}
                                            >
                                              <SVG
                                                src={require("../../../../../assets/images/UserManagement/close.svg")}
                                              />
                                            </span>
                                          </div>
                                        </div>
                                      );
                                    })}
                                  {/* </Scrollbars> */}
                                </div>
                              </div>
                            </Col>
                          ) : (
                            ""
                          )}
                        </Row>
                        <Row>
                          <Col md={10} className="mt-3">
                            <div className=" onboarding-restaurant-details-margin">
                              <div className="row align-items-center">
                                <div className="col-9">
                                  <NewInputText
                                    extraClass="mb-1"
                                    name="keywordsText"
                                    onChange={onKeywordsChangeHandler}
                                    value={keywordsText}
                                    labelText="Keywords"
                                    onKeyDown={(e) => {
                                      if (
                                        e.key === "Enter" &&
                                        keywordsText !== ""
                                      )
                                       if(addKeywordsAction) addKeywordsAction(e);
                                    }}
                                  />
                                  <div className="MuiFormHelperText-root MuiFormHelperText-root Mui-error ">
                                    {errors.keywordsText}
                                  </div>
                                  <div className="opacity5 f10-400">
                                    (Your keywords for the food item will help
                                    people find the item with ease )
                                  </div>
                                </div>
                                <div className="col-3">
                                  <AddButtonIconComponent
                                    buttonText="Add Keywords"
                                    onClick={addKeywordsAction}
                                    fontIcon="fa fa-plus"
                                    colorCss="blue"
                                  />
                                </div>
                              </div>
                            </div>
                          </Col>
                          <Col md={8} className="mt-3">
                            {keywords && keywords.length > 0 ? (
                              <div className="col-12 p-0 onboarding-restaurant-details-margin">
                                <div className="row enChipBox border-0">
                                  {/* <Scrollbars
                                  style={{ width: "100%", height: 135 }}
                                > */}
                                  {keywords &&
                                    keywords.map((data, index) => {
                                      return (
                                        <div className="mb-3 mr-3" key={index}>
                                          <div className="keywords_button">
                                            <p>{data}</p>
                                            <span
                                              className="ml-2"
                                              onClick={removeKeywordsAction(
                                                index
                                              )}
                                            >
                                              <SVG
                                                src={require("../../../../../assets/images/UserManagement/close.svg")}
                                              />
                                            </span>
                                          </div>
                                        </div>
                                      );
                                    })}
                                  {/* </Scrollbars> */}
                                </div>
                              </div>
                            ) : null}
                          </Col>
                        </Row>
                        <Row className="mt-4">
                          <Col md={8}>
                            <NewInputText
                              labelText="Category Description *"
                              extraClass="mb-1 w-100"
                              multiline={true}
                              rows="4"
                              name="description"
                              //onChange={formik.handleChange}
                              onChange={(e) =>
                                Capitalize(e.target.value, "description")
                              }
                              value={formik.values.description}
                            />
                          </Col>
                        </Row>
                        {/* <Form.Label className="f14-500 mb-1">Add Photos</Form.Label>
                    <div className="d-flex flex-wrap">
                      <div className="enUploadBox">
                        <Image
                          src={require("../../../../../../../assets/images/UserManagement/uploadImg.svg")}
                          alt="uploadImg"
                          title="uploadImg"
                          fluid
                        />
                        <input
                          type="file"
                          accept=".png, .jpg, .jpeg"
                          onChange={uploadImage}
                        />
                      </div>
                      {file && (
                        <div className="enIconUploaded">
                          <button
                            type="button"
                            className="enCloseButton"
                            onClick={() => setFile(null)}
                          >
                            <Image
                              src={require("../../../../../../../assets/images/UserManagement/en_close.svg")}
                              alt="uploadImg"
                              title="uploadImg"
                              fluid
                            />
                          </button>
                          <Image
                            src={file}
                            alt="icon"
                            title="icon"
                            className=""
                            fluid
                          />
                        </div>
                      )}
                    </div> */}
                        <hr />
                        <Form.Label className="f14-500 mb-3">
                          Category Classification
                        </Form.Label>
                        <div className="d-flex align-items-center">
                          {/* <div className="position-relative">
                        <div
                          className={
                            "mb-3 mr-3 onboarding_mapbutton_reusable justify-content-between onboarding_mapbutton_reusable_active_two onboarding_mapbutton_reusable_type"
                          }
                        >
                          <div className="d-flex align-items-center">
                            <img
                              src={
                                "https://amealia.s3.amazonaws.com/categoryicons/superadminCategoryicon-180-0013.png"
                              }
                              alt="icon"
                              title="Soups"
                            />

                            <span className="para-data-icon">Soups</span>
                          </div>
                        </div>
                      </div>
                      <div className="position-relative">
                        <div
                          className={
                            "mb-3 mr-3 onboarding_mapbutton_reusable justify-content-between onboarding_mapbutton_reusable_type onboarding_mapbutton_reusable_active"
                          }
                        >
                          <div className="d-flex align-items-center">
                            <img
                              src={
                                "https://amealia.s3.amazonaws.com/categoryicons/superadminCategoryicon-180-0013.png"
                              }
                              alt="icon"
                              title="Starters"
                            />

                            <span className="para-data-icon">Starters</span>
                          </div>
                        </div>
                      </div> */}
                          <div className="mb-1 d-flex flex-wrap">
                            {categoryClassification &&
                              categoryClassification.map((item, index) => (
                                <div
                                  className="enCheckWithText small"
                                  key={index}
                                >
                                  <input
                                    id="category_classification"
                                    type="radio"
                                    name="category_classification"
                                    value={item.title}
                                    onChange={formik.handleChange}
                                    checked={
                                      formik.values.category_classification ===
                                      item.title
                                    }
                                  />
                                  <label className="w-100 d-flex align-items-center justify-content-center">
                                    {item.title}
                                  </label>
                                </div>
                              ))}
                          </div>
                        </div>
                        {formik.errors.category_classification &&
                        formik.touched.category_classification ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.category_classification}
                          </div>
                        ) : null}
                        <Form.Label className="f14-500 my-3">
                          Product Classification
                        </Form.Label>
                        <Row>
                          {productClassification.map((item, index) => (
                            <Col xs={6} md={3} key={index}>
                              <label className="enRadioWithText small f12-400 w-100 mb-3">
                                {item.name}
                                <input
                                  id="product_classification"
                                  type="radio"
                                  name="product_classification"
                                  value={item.name}
                                  onChange={formik.handleChange}
                                  checked={
                                    formik.values.product_classification ===
                                    item.name
                                  }
                                />
                                <span className="checkmark"></span>
                              </label>
                            </Col>
                          ))}
                        </Row>
                        {formik.errors.product_classification &&
                        formik.touched.product_classification ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.product_classification}
                          </div>
                        ) : null}
                        <div
                          style={{ position: "relative" }}
                          className="mobile-center onboarding-map-setup-screen-autodetect-button justify-content-between mt-5"
                        >
                          <div>
                            <ReusableOnboardingLink
                              buttonTitle="Back Button"
                              buttonClass="btn-lg btn btn-outline-secondary"
                              buttonText="Cancel"
                              // link="/casual-fine-dining/menusetup"
                              link={
                                "/superadmin-global-items-management/category"
                              }
                            />
                            <ReusableOnboardingButton
                              buttonTitle="Next Button"
                              buttonClass="btn-lg btn btn-danger btn-lg ml-3 "
                              buttonText="Submit"
                              buttonType="button"
                              // onClick={() => handleNextStep(2)}
                              onClick={(e) => onClickNext(e)}
                              // onClick={() => onClickSave()}
                            />
                          </div>
                        </div>
                      </React.Fragment>
                    )}
                    {step === 2 && (
                      <React.Fragment>
                        <div className="nav-scroller mb-4">
                          <ul
                            className="enStepNav nav list-unstyled d-flex justify-content-between"
                            style={{ width: 300 }}
                          >
                            <li className="pho_24_medium done">
                              <div className="stepNumber">01</div>
                              <div className="text">Define Category</div>
                            </li>
                            <li className="doing">
                              <div className="stepNumber">02</div>
                              <div className="text">Taxes & Other Details</div>
                            </li>
                          </ul>
                        </div>
                        <Row>
                          <Col md={8}>
                            <NewInputText
                              labelText="Category Name"
                              extraClass="mb-3 w-100"
                              value={formik.values.name}
                              disabled={true}
                            />
                          </Col>
                        </Row>
                        <Form.Label className="f16-500 my-3">
                          Taxes & Other Charges
                        </Form.Label>
                        <Row className="align-items-center py-3">
                          <Col xs={6}>
                            <div className="f14-700">Price Includes Taxes</div>
                            <div className="f11-400 opacity5">
                              (Taxes are same for all the items in the category)
                            </div>
                          </Col>
                          <Col xs={6}>
                            <ToggleButtonWithYesNo
                              activeClass={WithTaxes}
                              checkedBox={WithTaxes}
                              onChange={handleWithTaxes}
                            />
                          </Col>
                        </Row>
                        <hr />

                        {!WithTaxes ? (
                          <Fragment>
                            <div
                              className="d-flex align-items-center text-red f14-500 cursor my-4"
                              onClick={() => setShowAddedTaxes(!showAddedTaxes)}
                              //onClick={handleShowTaxSurcharges}
                            >
                              Show added Tax and Surcharges{" "}
                              <KeyboardArrowDownIcon />
                            </div>
                            {showAddedTaxes ? (
                              <Fragment>
                                {taxValues.map((item, index) => (
                                  <TaxesSurCharges
                                    changeHandle={(e, name) =>
                                      onChangeValue(e, name, item._id)
                                    }
                                    key={index}
                                    tax_name={item.tax_name}
                                    curb_side={item.curb_side}
                                    take_away={item.take_away}
                                    dine_in_order={item.dine_in_order}
                                    skip_line={item.skip_line}
                                    tax_value={item.tax_value}
                                    orderingData={{
                                      take_away: { value: showTakeAway },
                                      skip_line: { value: showSkipTheLine },
                                      dine_in_order: { value: showDineIn },
                                      curb_side: { value: showCurbSide },
                                      catering_banquet: { value: false },
                                      home_delivery: { value: false },
                                      //                                      cubside_delivery: { value: false },
                                    }}
                                  />
                                ))}
                                {addNewTaxes.length > 0 ? (
                                  <Fragment>
                                    <div
                                      className="f14-400 mb-4 "
                                      style={{
                                        color: "#2096F3",
                                        cursor: "pointer",
                                      }}
                                      onClick={openAddSurcharges}
                                    >
                                      Add/Maintain Tax/Surchages
                                    </div>
                                    <AddSurchargesModel
                                      //tax_value={item.tax_value}
                                      closeAddSurcharges={closeAddSurcharges}
                                      open={addsurcharges}
                                      taxInfo={addNewTaxes}
                                      take_away={showTakeAway}
                                      skip_line={showSkipTheLine}
                                      dine_in_order={showDineIn}
                                      curb_side={showCurbSide}
                                      catering_banquet={false}
                                      home_delivery={false}
                                      // cubside_delivery={showCurbSide}
                                      onClickSaveModalData={(data) =>
                                        onClickSaveModalData(data)
                                      }
                                    />
                                  </Fragment>
                                ) : (
                                  <> </>
                                )}
                              </Fragment>
                            ) : (
                              <> </>
                            )}
                          </Fragment>
                        ) : (
                          <Fragment></Fragment>
                        )}
                        <div className="onboarding-map-setup-screen-autodetect-button justify-content-between mt-5">
                          <div>
                            <ReusableOnboardingButton
                              buttonTitle="Back Button"
                              buttonClass="btn-lg btn btn-outline-secondary"
                              buttonText="Back"
                              onClick={() => handleNextStep(1)}
                            />
                            <ReusableOnboardingButton
                              buttonTitle="Next Button"
                              buttonClass="btn-lg btn btn-danger btn-lg ml-3 "
                              buttonText="Save"
                              buttonType="button"
                              onClick={(e) => onClickSave(e)}
                            />
                          </div>
                        </div>
                      </React.Fragment>
                    )}
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      )}
    </>
  );
};

SuperAdminAddCategory.propTypes = {
  auth: PropTypes.object.isRequired,
  add_category_admin_menu_setup: PropTypes.func.isRequired,
  edit_category_admin_menu_setup: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  categoryClassification: state?.category?.category_classification,
  activeCategoryData: state.commonSuperAdmin.activeCategoryData,
  servicesEnabled:
    state.onboarding &&
    state.onboarding.onboard_subscription_details &&
    state.onboarding.onboard_subscription_details.casual_dining_status &&
    state.onboarding.onboard_subscription_details.casual_dining_status.ordering,
  checkSkipLine:
    state.onboarding && state.onboarding.onboard_subscription_details,
  subscriptionData:
    state.onboarding &&
    state.onboarding.onboard_subscription_details &&
    state.onboarding.onboard_subscription_details.casual_dining_status &&
    state.onboarding.onboard_subscription_details.casual_dining_status
      .ordering &&
    state.onboarding.onboard_subscription_details.casual_dining_status.ordering
      .order_general,
});

export default connect(mapStateToProps, {
  add_category_admin_menu_setup,
  edit_category_admin_menu_setup,
})(SuperAdminAddCategory);
